import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Form from './Form'
import { formTypeList } from '../../constants/form'
import { GET_ONE_ITEM_STYLE } from '../../store/types'
import { getOneItemStyle } from '../../store/actions/itemStyleAction'

const Edit = ({ id, setOpen }) => {
    const dispatch = useDispatch()
    const { itemStyle } = useSelector((state) => state.itemCategory)
    useEffect(() => {
        dispatch(getOneItemStyle(id))
        return () => {
            dispatch({
                type: GET_ONE_ITEM_STYLE,
                payload: null,
            })
        }
    }, [dispatch, id])
    return itemStyle ? (
        <Form
            formType={formTypeList.EDIT}
            setOpen={setOpen}
            propsValue={itemStyle}
        />
    ) : null
}

export default Edit
